/* eslint-disable no-unused-vars */
import platform from 'platform';
import { v4 as uuidv4 } from 'uuid';
import store from '@/store';

const userAgentInfo = platform.parse(navigator.userAgent);

const userDeviceInfo = {
  device: '',
  operatingSystem: '',
  browserType: '',
  title: document.title,
  url: window.location.href,
};

function getDeviceType() {
  const { userAgent } = navigator;
  if (userAgent.indexOf('Windows') !== -1 && userAgent.indexOf('Windows Phone') === -1) {
    userDeviceInfo.device = 'Windows Desktop';
  } else if (userAgent.indexOf('Macintosh') !== -1) {
    userDeviceInfo.device = 'Mac';
  } else if (userAgentInfo.product) {
    userDeviceInfo.device = userAgentInfo.product;
  } else {
    userDeviceInfo.device = 'unknown';
  }
}

function getOperatingSystem() {
  userDeviceInfo.operatingSystem = `${userAgentInfo.os.family} ${userAgentInfo.os.version}`;
}

function getBrowserType() {
  const { userAgent } = navigator;
  if (/Firefox/i.test(userAgent)) {
    userDeviceInfo.browserType = 'Firefox';
  } else if (/Chrome/i.test(userAgent)) {
    userDeviceInfo.browserType = 'Chrome';
  } else if (/Safari/i.test(userAgent)) {
    userDeviceInfo.browserType = 'Safari';
  } else if (/Edge/i.test(userAgent)) {
    userDeviceInfo.browserType = 'Edge';
  } else if (/MSIE/i.test(userAgent)) {
    userDeviceInfo.browserType = 'IE';
  }
}

function getUuid() {
  const myUuid = uuidv4();
  return myUuid;
}

function getSessionId() {
  let sessionId = sessionStorage.getItem('sessionID');
  if (!sessionId) {
    sessionId = getUuid();
    sessionStorage.setItem('sessionID', sessionId);
  }
}

function getDeviceId() {
  let machineId = localStorage.getItem('MachineId');
  if (!machineId) {
    machineId = getUuid();
    localStorage.setItem('MachineId', machineId);
  }
}

// 取得用戶資訊(deviceType, os, sessionId...)
function initUserDeviceInfo() {
  getDeviceType();
  getOperatingSystem();
  getBrowserType();
  getSessionId();
  getDeviceId();
  store.dispatch('userBehavior/updateUserDeviceInfo', userDeviceInfo);
}

export default initUserDeviceInfo;
